import { Component, OnInit } from '@angular/core';

import {RightContainerService} from '../right-container.service';

@Component({
  selector: 'app-info-crypto-repo-confirmation',
  templateUrl: './info-crypto-repo-confirmation.component.html',
  styleUrls: ['./info-crypto-repo-confirmation.component.scss']
})
export class InfoCryptoRepoConfirmationComponent implements OnInit {

  constructor(private rightContainer: RightContainerService) { }

  ngOnInit() {
  }

}
